<template>
    <div>
        <!-- Panel -->
        <HeaderCard />
        <panel title="DOKUMEN SURAT PEMBERITAHUAN" class="panel panel-dark">
            <b-card>
                <div class="py-2">
                    <div class="float-right">
                        <!-- <span class="px-2"><b-button variant="primary" @click="showSptp"><i class="fa fa-list"></i> {{ judulButton }}</b-button></span> -->
                        <!-- <span><b-button variant="primary" class="px-4" @click="printDoc"><i class="fa fa-print mr-2"></i> Print & Preview</b-button></span> -->
                    </div>
                </div>
                <br />
                <div class="text-center mb-3">
                    <h1>
                        TERIMA KASIH
                    </h1>
                    <p>
                        Anda telah melaporkan data wajib retribusi pada masa
                        retribusi ini. <br />
                        Untuk melihat data yang telah dilaporkan silahkan klik
                        tombol di bawah ini.
                    </p>
                </div>
                <div class="my-5 row">
                    <div class="col-lg-4"></div>
                    <!-- begin col-4 -->
                    <div class="col-lg-4" @click="rincianPdf(spt_id)">
                        <div
                            class="widget widget-stats bg-gradient-teal m-b-10 custom-hover"
                        >
                            <div class="stats-icon stats-icon-lg">
                                <i class="fa fa-file-pdf fa-fw"></i>
                            </div>
                            <div class="stats-content">
                                <div class="stats-title">
                                    BADAN PENGELOLAAN PAJAK DAN RETRIBUSI DAERAH
                                </div>
                                <div class="stats-number" style="height: 6rem">
                                    DOKUMEN SPT
                                </div>
                                <div class="stats-desc">
                                    Rincian Dokumen Surat Pemberitahuan Hasil
                                    Pengelolaan Kekayaan Daerah yang Dipisahkan
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4"></div>
                </div>

                <b-modal
                    v-model="helper.showLoader"
                    id="modalLoader"
                    hide-footer
                    hide-header
                    no-close-on-backdrop
                    centered
                    size="sm"
                >
                    <div class="text-center">
                        <b-spinner
                            variant="light"
                            label="Text Centered"
                        ></b-spinner>
                        <h5>Harap Menunggu...</h5>
                        <div>Data Anda Sedang Di Proses</div>
                    </div>
                </b-modal>
            </b-card>
        </panel>
    </div>
</template>

<script>
/* eslint-disable */
// eslint-disable-next-line
// eslint-disable vue/no-unused-vars
// eslint-disable-line no-unused-vars
import HeaderCard from "@/components/header/HeaderCard.vue";
import cekAuthMixins from "@/helper/cek401";
import axios from "axios";

export default {
    mixins: [cekAuthMixins],
    components: {
        HeaderCard
    },
    data() {
        return {
            helper: {
                pdfUrl: "",
                showLoader: false
            },
            spt_id: JSON.parse(localStorage.getItem("spt_id"))
        };
    },
    methods: {
        // view pdf dari spt
        async rincianPdf(spt_id) {
            try {
                this.helper.showLoader = true;
                let response = await axios.get(
                    `/api/view-pdf/surat/spt/detail/spt-${spt_id}`,
                    { responseType: "arraybuffer" }
                );
                if (response.data) {
                    this.helper.showLoader = false;
                    this.helper.pdfUrl = window.URL.createObjectURL(
                        new Blob([response.data], { type: "application/pdf" })
                    );
                    window.open(this.helper.pdfUrl, "_blank");
                }
            } catch (error) {
                this.helper.showLoader = false;
                console.log(error);
                if (error.response.status == 401) {
                    // mixins - cek auth
                    this.cekAuth();
                }
            }
        }
    }
};
</script>

<style scoped>
.custom-hover:hover {
    /* box-shadow: 5px 5px rgba(68, 67, 67, 0.281); */
    cursor: pointer;
    transform: scale(1.05);
    transition: all ease 0.4s;
}
</style>
